import { useState, useEffect,useRef,useCallback } from "react";
import {
  Image,
  Row,
  Col,
  Typography,
  Divider,
  Button,
  message,
  Card,
  Descriptions,
  Space,
} from "antd";
import { 
  TwitterOutlined,
  FacebookOutlined,
  WhatsAppOutlined,
  InstagramOutlined,
} from "@ant-design/icons";
import { useParams, useHistory } from "react-router";
import { useSelector } from "react-redux";
import { selectUser } from "../../../Auth/userReducer";
import UserService from "../../../services/UserService.js";
import PictureForm from "./PictureForm";
import ContactForm from "./ContactForm";
import SocialNetworksForm from "./SocialNetworksForm.jsx";

const { Title, Text } = Typography;

const {Item}=Descriptions

export default function Profile() {
  const history = useHistory();
  const params = useParams();
  const [user, setUser] = useState(null);
  const [userAnotherSocialNetworks, setUserAnotherSocialNetworks] = useState(null);
  const [isAtuh, setisAtuh] = useState(false);
  const [isModalPhotoVisible, setIsModalPhotoVisible] = useState(false);
  const [isModalContactVisible, setisModalContactVisible] = useState(false);
  const [isModalSocialNetworksVisible, setisModalSocialNetworksVisible] = useState(false);
  /* const showModalPhoto = () => {
    setIsModalPhotoVisible(true);
  }; */

  const handleOkPhoto = () => {
    setIsModalPhotoVisible(false);
    getUser(userId);
  };

  const handleCancelPhoto = () => {
    setIsModalPhotoVisible(false);
  };

  /*   const showModalContact = () => {
    setisModalContactVisible(true);
  }; */

  const handleOkContact = () => {
    setisModalContactVisible(false);
    getUser(userId);
  };

  const handleCancelContact = () => {
    setisModalContactVisible(false);
  };

  const handleOkSocialNetworks = () => {
    setisModalSocialNetworksVisible(false);
    getUser(userId);
  };

  const handleCancelSocialNetworks = () => {
    setisModalSocialNetworksVisible(false);
  };

  const {current:userId} = useRef(parseInt(params.id));
  let globalUser = useSelector(selectUser);
  const {current:userSesion} = useRef(globalUser);

  const getUser = useCallback(
    (id) => {
      UserService.getUserById(id)
        .then((res) => {
          if (res.data?.success) {
            //console.log("user", res.data.response);
            let userView = res.data.response;
            if (
              userSesion?.rolName === "Administrador" ||
              userSesion?.id === userView.id
            ) {
              setisAtuh(true);
            }
            setUser(userView);
            setUserAnotherSocialNetworks(userView.Contact.anotherSocialNetworks)
          } else {
            message.error("No se pudo obtener información.");
          }
        })
        .catch((e) => {
          //message.error("Hubo un problema. " + e.message, 5);
          console.log("error", e.message);
        });
    },
    [userSesion],
  );

  const createItemsOthersSocialNetworks=(items)=>{
    let component=null;
    if(items!=null){
      component=items.map((item,index)=>{
        return <Item key={"CEA"+index} label={item?.SocialNetworkNewName} span={3}>{item?.SocialNetworkNewUser || "Sin email"}</Item>
      })
    }
    else{
      component=<Item key={"NSN--1"} label={"Sin otras redes sociales"} span={3}>{"Sin datos"}</Item>
    }
    return component
  }

  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
  }, [userId,getUser]);

  return (
    <>
      <Row align="center">
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "1em",
          }}
        >
          {user?.picture ? (
            <Image
              width={250}
              height={250}
              src={`https://drive.google.com/uc?export=download&id=${user?.picture}`}
              style={{ borderRadius: "50%", objectFit: "cover" }}
              //fallback="data:image/png;base64,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"
            />
          ) : (
            <Image
              width={200}
              height={200}
              src="error"
              style={{ borderRadius: "50%" }}
              fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
            />
          )}
        </Col>
        {isAtuh ? (
          <Col
            span={22}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setIsModalPhotoVisible(true);
              }}
            >
              Cambiar Foto
            </Button>
          </Col>
        ) : null}
      </Row>
      <Divider></Divider>
      <Row
        align="center"
        style={{
          marginTop: "2em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
         <Card>
          <Descriptions title="Información de Personal" layout="horizontal" bordered>
              <Item key={"FN"+user?.id} label="Nombres" span={3}>{user?.firstName|| "Sin info"}</Item>
              <Item key={"LN"+user?.id} label="Apellidos" span={3}>{user?.lastName || "Sin info"}</Item>
              <Item key={"RC"+user?.id} label="Rol de la cuenta" span={3}>{user?.SystemRol?.name || "Sin info"}</Item>
              <Item key={"CE"+user?.id} label="Correo electronico asociado" span={3}>{user?.email || "Sin info"}</Item>
          </Descriptions>
         </Card>
      </Row>
      <Divider></Divider>
      <Row
        align="center"
        style={{
          marginTop: "2em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
         <Card>
          <Descriptions title="Información de Contacto" layout="horizontal" bordered>
              <Item key={"CEC"+user?.id} label="Correo electronico Alternativa" span={3}>{user?.Contact?.email || "Sin email"}</Item>
              <Item key={"Cell"+user?.id} label="Celular" span={3}>{user?.Contact?.cellPhone || "Ninguno"}</Item>
              <Item key={"Telf"+user?.id} label="Telefono" span={3}>{user?.Contact?.phone || "Ninguno"}</Item>
              <Item key={"Pass"+user?.id} label="N Pasaporte" span={3}>{user?.Contact?.passport || "Ninguno"}</Item>
              <Item key={"UCI"+user?.id} label="C.I." span={3}>{user?.Contact?.userCI || "Ninguno"}</Item>
              <Item key={"Country"+user?.id} label="País" span={3}>{user?.Contact?.ubication || "Sin País"}</Item>
              <Item key={"SNW"+user?.id} label="Redes sociales" span={3}>{ 
              <>
                <Space direction="vertical">
                  <Text> <FacebookOutlined /> {user?.Contact?.socialNetworks?.facebook}</Text>

                  <Text> <WhatsAppOutlined /> {user?.Contact?.socialNetworks?.whatsapp}</Text>

                  <Text>  <InstagramOutlined /> {user?.Contact?.socialNetworks?.instagram}</Text>

                  <Text> <TwitterOutlined />  {user?.Contact?.socialNetworks?.twitter }</Text>
                </Space>
              </>
              ||"Sin información"
          }</Item>
          </Descriptions>
         </Card>
      </Row>
      <Row align="center" style={{ marginTop: "2em" }}>
      {isAtuh && (
          <>
          <Col
            span={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setisModalContactVisible(true);
              }}
            >
              Editar información de contacto
            </Button>
          </Col>
          </>
          )
      }
      </Row>
      <Divider></Divider>
      <Row
        align="center"
        style={{
          marginTop: "2em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
         <Card>
          <Descriptions title="Otras redes sociales" layout="horizontal" bordered>
              {createItemsOthersSocialNetworks(userAnotherSocialNetworks)}
          </Descriptions>
         </Card>
      </Row>
      {/* <Divider>
        <Title level={4}>Información de Personal</Title>
      </Divider>
      <Row
        align="center"
        style={{
          marginTop: "2em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Title level={2}>{user?.firstName + " " + user?.lastName}</Title>
        </Col>
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Title level={5}>{user?.SystemRol?.name}</Title>
        </Col>
      </Row>
      <Row
        align="center"
        style={{
          marginTop: "2em",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text strong>{user?.email}</Text>
        </Col>
      </Row>
      {user?.SystemRol?.name === "Estudiante" ? (
        <>
          <Row align="center" style={{ marginTop: "2em" }}>
            <Col
              span={22}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Title level={5}>{user?.Career?.name}</Title>
            </Col>
          </Row>
          <Row align="center" style={{ marginTop: "2em" }}>
            <Col
              span={22}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Title level={5}>{user?.Institution?.name}</Title>
            </Col>
          </Row>
        </>
      ) : null}
      <Divider>
        <Title level={4}>Información de Contacto</Title>
      </Divider>
      <Row align="center" style={{ marginTop: "2em" }}>
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>
            Correo electrónico:{" "}
            <strong>{user?.Contact?.email || "Sin email"}</strong>
          </span>
        </Col>
      </Row>
      <Row align="center" style={{ marginTop: "2em" }}>
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>
            Número Telefono/Celular:{" "}
            <strong>{user?.Contact?.phone || "ninguno"}</strong>
          </span>
        </Col>
      </Row>
      <Row align="center" style={{ marginTop: "2em" }}>
        <Col
          span={22}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>
            País: <strong>{user?.Contact?.ubication || "Sin País"}</strong>
          </span>
        </Col>
      </Row> */}

      <Row align="center" style={{ marginTop: "2em" }}>
        {isAtuh && (
          <>
          <Col
          span={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setisModalSocialNetworksVisible(true);
            }}
          >
            Editar información de otras redes sociales
          </Button>
        </Col>
        </>
        )}
      </Row>
      {user?.UserProjects?.length > 0 && (
        <>
          <Divider>
            <Title level={4}>Proyectos</Title>
          </Divider>
          <Row
            align="center"
            style={{ marginTop: "25px", marginBottom: "25px" }}
            gutter={[24, 32]}
          >
            {user?.UserProjects?.map((d) => (
              <Col
                key={d.id}
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 12 }}
                lg={{ span: 7 }}
                xl={{ span: 7 }}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Card
                  style={{ width: "300px", borderRadius: "5px" }}
                  onClick={() => {
                    history.push(`/project/view/${d.Project?.id}`);
                  }}
                >
                  <p>
                    <b>{d.Project?.title}</b>
                  </p>
                  <p>{d.Project?.code}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}

      {isModalPhotoVisible ? (
        <PictureForm
          isModalVisible={isModalPhotoVisible}
          handleOk={handleOkPhoto}
          handleCancel={handleCancelPhoto}
          pictureId={user?.picture}
          userId={user?.id}
        />
      ) : null}
      {isModalContactVisible ? (
        <ContactForm
          isModalVisible={isModalContactVisible}
          handleOk={handleOkContact}
          handleCancel={handleCancelContact}
          contact={user?.Contact}
        />
      ) : null}
      {isModalSocialNetworksVisible ? (
        <SocialNetworksForm
          isModalVisible={isModalSocialNetworksVisible}
          handleOk={handleOkSocialNetworks}
          handleCancel={handleCancelSocialNetworks}
          contact={user?.Contact?.anotherSocialNetworks}
        />
      ) : null}
    </>
  );
}
